import vueFilePond, {
  setOptions
} from 'vue-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

const Uploader = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview)

setOptions({
  fileMetadataObject: null,
  server: {
    process: null,
    revert: null,
    restore: null,
    load: null,
    fetch: null,
  }
})

export default Uploader
